// extracted by mini-css-extract-plugin
export default {"TooltipNotification":"TooltipNotification_TooltipNotification__pDsRQ"};